import { createContainer, createHook, createStore } from 'react-sweet-state';
import { teamsClient } from '@atlassian/teams-client';
import { promiseWithDefault } from '../../common/utils/promise';
import { getSettingsFromStorage } from '../feature-flags';
export const BROWSE_USER_SETTINGS_KEY = 'internal.browse-users-allowed';
const actions = {
  /**
   * Fetches feature flag settings from LaunchDarkly via activity service and directory service
   * Caches the fetched settings in local storage to be used as optimistic settings on next load
   * @param product - only Embeddable Directory needs product information. Standalone app does not need this.
   * @param cloudId - Cloud Id.
   */
  getSettings: (product, cloudId) => async ({
    setState
  }) => {
    // in siteless, we don't need to query features flags in directory
    const directorySettingPromise = cloudId ? teamsClient.querySettings(cloudId, product) : Promise.resolve({
      [BROWSE_USER_SETTINGS_KEY]: true
    });
    return promiseWithDefault(directorySettingPromise, {
      [BROWSE_USER_SETTINGS_KEY]: false
    }).then(({
      value: browseUsersEnabled,
      success: settingsSuccess
    }) => {
      const settingsFromRequests = {
        // If settings cannot be accessed, default to permission denied.
        [BROWSE_USER_SETTINGS_KEY]: false,
        ...browseUsersEnabled
      };
      if (settingsSuccess) {
        setState({
          hasLoadedSettings: true,
          hasBrowseUsersPermission: !!settingsFromRequests[BROWSE_USER_SETTINGS_KEY],
          settings: {
            ...settingsFromRequests
          }
        });
      }

      // Fallback as needed to compute effective flag values
      const finalSettings = {
        ...(getSettingsFromStorage() || {}),
        ...settingsFromRequests
      };
      setState({
        hasLoadedSettings: true,
        hasErrorOnFetchSettings: !settingsSuccess,
        hasBrowseUsersPermission: !!finalSettings[BROWSE_USER_SETTINGS_KEY],
        settings: finalSettings
      });
    });
  }
};
const initialState = {
  hasLoadedSettings: false,
  hasErrorOnFetchSettings: false,
  hasBrowseUsersPermission: false,
  settings: {
    [BROWSE_USER_SETTINGS_KEY]: false,
    ...(getSettingsFromStorage() || {})
  }
};

/**
 * Manage states of settings
 */
const Store = createStore({
  initialState,
  actions,
  name: 'Settings'
});
export const SettingsContainer = createContainer(Store, {
  onInit: () => ({
    setState
  }, state) => {
    setState(state);
  }
});
export const useSettings = createHook(Store);

/**
 * @deprecated As part of decommisioning pf-directoy
 */
export const useSettingsFeatureFlag = flagName => {
  const [{
    settings
  }] = useSettings();
  return settings[flagName];
};